export function parseOptionalNonNegativeInt(value, label) {
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }
    const parsed = Number.parseInt(trimmed, 10);
    if (!Number.isFinite(parsed) || parsed < 0 || String(parsed) !== trimmed) {
        return `${label} must be a non-negative whole number.`;
    }
    return parsed;
}
//# sourceMappingURL=parse-optional-non-negative-int.js.map